// @flow

import React, {useEffect, useState} from "react";
import Modal from "react-modal";
import type {translate} from "../../i18next";
import i18n from "../../i18next";
import Loading from "../layout/Loading";
import {loadNoticeDocument, noticePortalUrlFor} from "../../helper/empco/euGuarantee";
import {modalStyles} from "./modalStyles";
import {ExternalLink, X} from "lucide-react";
import Icon from "../icons/Icon";
import "./empco.scss";

export type WarrantyNoticeModalProps = {
    isOpen: boolean,
    onRequestClose: () => void,
    t: translate,
    // defaults to the language the products are displayed in
    language?: string,
};

// Popup with the EU harmonised notice on the legal guarantee of conformity (#56431). The document is
// fully prescribed by the EU and shown as is, in the display language of the module (fallback: English).
const WarrantyNoticeModal = ({isOpen, onRequestClose, t, language}: WarrantyNoticeModalProps) => {
    const displayLanguage = language || i18n.language;
    const [documentUrl, setDocumentUrl] = useState(null);

    useEffect(() => {
        if (!isOpen) {
            return undefined;
        }
        let cancelled = false;
        setDocumentUrl(null);
        loadNoticeDocument(displayLanguage).then(url => {
            if (!cancelled) {
                setDocumentUrl(url);
            }
        });
        return () => {
            cancelled = true;
        };
    }, [isOpen, displayLanguage]);

    return (
        <Modal isOpen={isOpen}
               style={modalStyles}
               shouldCloseOnOverlayClick={true}
               onRequestClose={onRequestClose}
               contentLabel={t("warranty.notice.link")}
        >
            <button type={"button"} aria-label={t("footer.closeModal")} onClick={onRequestClose}
                    className="hpm-modalClose"><Icon icon={X} size={24}/></button>
            <div className="hpm-modalContent hpm-warrantyNotice" style={{fontFamily: "var(--font100)"}}>
                {documentUrl
                    ? <img className="hpm-warrantyNotice-document"
                           src={documentUrl}
                           alt={t("warranty.notice.alt")}
                           data-testid="warranty-notice-document"/>
                    : <Loading height={200}/>
                }
                <a className="hpm-warrantyNotice-link"
                   href={noticePortalUrlFor(displayLanguage)}
                   target={"_blank"} rel={"noopener noreferrer"}>
                    {t("warranty.notice.euLink")}
                    <Icon icon={ExternalLink} size={16} className="hpm-externalLinkIcon"/>
                </a>
            </div>
        </Modal>
    );
};

export default WarrantyNoticeModal;
